export enum ProductionRecurringFormFields {
  enableRecurring = "enableRecurring",
  sendToSupplierAfterProduce = "sendToSupplierAfterProduce",
  times = "times",
}
